import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      paddingTop: 10,
    },
    paragraph: {
        margin: '20px 10px',
    }
  }));

export default function About(props) {
    const classes = useStyles();

    return (
        <Grid container justify="center">
            <Grid item xs md={4}>
                <Typography align="justify" component="p" color="textPrimary" className={classes.paragraph}>
                    Esta aplicação é um projeto independente, cedido como um produto da Biblioteca Central Zila Mamede da Universidade Federal do Rio Grande do Norte, para uso de toda a comunidade acadêmica desta instituição.
                </Typography>
                <Typography align="justify" component="p" color="textPrimary" className={classes.paragraph}>
                    O Bibliotecas UFRN foi desenvolvido por:
                </Typography>

                <List>
                    <ListItem divider={true}>
                        <ListItemText primary="Anderson Queiroz" secondary="Desenvolvedor Full Stack" />
                    </ListItem>
                    <ListItem divider={true}>
                        <ListItemText primary="Franklin Dias" secondary="Desenvolvedor Full Stack" />
                    </ListItem>            
                    <ListItem divider={true}>
                        <ListItemText primary="Manaia Junior" secondary="Desenvolvedor Full Stack" />
                    </ListItem>
                </List>
                <Box display="flex" p={1} justifyContent="center">
                    <Button 
                        color="primary" 
                        fullWidth={true}
                        onClick={ () => props.history.goBack() }>
                            Voltar
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
}